import { userAccount } from './user-account';

export const en = {
  userAccount,
};
